import api from './client';
import type { CampaignPostback, PostbackLogRow } from './tracker-types';

export type PostbackInput = {
  name: string;
  url: string;
  method: 'GET' | 'POST';
  events: string[];
  sources: string[];
  status?: 'active' | 'paused';
};

export const listPostbacks = (campaignId: string) =>
  api.get<CampaignPostback[]>(`/admin/tracker/campaigns/${campaignId}/postbacks`);

export const createPostback = (campaignId: string, data: PostbackInput) =>
  api.post<CampaignPostback>(`/admin/tracker/campaigns/${campaignId}/postbacks`, data);

export const updatePostback = (id: string, data: Partial<PostbackInput>) =>
  api.put<CampaignPostback>(`/admin/tracker/postbacks/${id}`, data);

export const deletePostback = (id: string) =>
  api.delete<{ message: string }>(`/admin/tracker/postbacks/${id}`);

export const getPostbackLog = (id: string, limit = 50) =>
  api.get<PostbackLogRow[]>(`/admin/tracker/postbacks/${id}/log?limit=${limit}`);
